var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(-11327 -5419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633243",
    "data-name": "Group 633243",
    transform: "translate(11327 5419)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37820",
    "data-name": "Ellipse 37820",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(0)",
    fill: "#ff355b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(11332 5423.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-2",
    "data-name": "close"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204235",
    "data-name": "Rectangle 204235",
    width: 15,
    height: 15,
    transform: "translate(15 15.333) rotate(180)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858296",
    "data-name": "Path 858296",
    d: "M12.759,11.473,16.681,7.56a.916.916,0,0,0-1.3-1.3l-3.913,3.923L7.559,6.264a.916.916,0,0,0-1.3,1.3l3.922,3.914L6.264,15.387a.916.916,0,1,0,1.3,1.3l3.913-3.923,3.913,3.923a.916.916,0,1,0,1.3-1.3Z",
    transform: "translate(-3.806 -3.807)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlert);
export default __webpack_public_path__ + "static/media/ErrorAlert.fe61975144a3f29b1514a09ffe716854.svg";
export { ForwardRef as ReactComponent };